import React, { CSSProperties } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendarAlt } from "@fortawesome/free-regular-svg-icons";

type OwnProps = {
  onClick?: any;
  value?: string;
  style?: CSSProperties;
};

const CustomDateBoxInput = React.forwardRef(
  ({ value, onClick, style }: OwnProps, ref: any) => {
    return (
      <div
        className="datePickerBoxBtn"
        onClick={onClick}
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          border: "1px solid #ccc",
          borderRadius: "6px",
          padding: "5px 10px",
          width: "130px",
          backgroundColor: "#fff",
          cursor: "pointer",
          ...style
        }}
        ref={ref}
      >
        <div
          style={{
            color: value ? "#455a64" : "#aaa",
            fontSize: "14px",
            letterSpacing: "0.3px",
            paddingTop: "3px"
          }}
        >
          {value || "PICK A DATE"}
        </div>

        <FontAwesomeIcon icon={faCalendarAlt} />
      </div>
    );
  }
);

export default CustomDateBoxInput;